<template>
  <div class="addNotice-container">
    <el-row class="b-20">
      <el-button type="primary" class="r-20" @click="preview">预览</el-button>
      <el-button type="primary" class="r-20" @click="saveAddNotice"
        >保存</el-button
      >
      <el-button class="r-20" @click="goBack">返回</el-button>
    </el-row>
    <el-row class="content">
      <!-- 选择通知车辆 -->
      <el-aside width="260px">
        <div class="aside-top">
          <div class="top-title">选择通知车辆</div>
        </div>
        <div class="aside-bottom">
          <div class="search">
            <el-input
              placeholder="请输入车牌号"
              v-model="plateNum"
              @keyup.enter.native="getPlateNumList"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getPlateNumList"
              ></el-button>
            </el-input>
          </div>
          <div class="search-data">
            <el-checkbox-group v-model="plateCheckList">
              <el-checkbox
                :label="item.plateNum"
                v-for="item in plateNumList"
                :key="item.vin"
              ></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-aside>
      <!-- 选择消息模版 -->
      <el-aside width="560px">
        <div class="aside-top">
          <div class="top-title">选择消息模版</div>
        </div>
        <div class="aside-bottom">
          <div class="search">
            <el-input
              placeholder="请输入消息模版"
              v-model="noticeMsg"
              @keyup.enter.native="getNoticeMessageList"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getNoticeMessageList"
              ></el-button
            ></el-input>
          </div>
          <div class="search-data">
            <el-checkbox-group v-model="noticeMsgIdList">
              <el-checkbox
                :label="item.id"
                v-for="item in noticeMessageList"
                :key="item.id"
              >
                <div style="margin-bottom:4px">
                  {{ item.name }}
                </div>
                <div>
                  {{ item.msg }}
                </div>
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-aside>
      <!-- 选择通知对象 -->
      <el-aside width="260px">
        <div class="aside-top">
          <div class="top-title">选择通知对象</div>
        </div>
        <div class="aside-bottom">
          <div class="search">
            <el-input
              placeholder="请输入产权方名称"
              v-model="PropertyOwnerName"
              @keyup.enter.native="getPropertyOwnerList"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getPropertyOwnerList"
              ></el-button
            ></el-input>
          </div>
          <div class="search-data">
            <el-tree
              ref="tree"
              :data="propertyOwnerList"
              node-key="id"
              show-checkbox
              :props="defaultProps"
              @check="selectClick"
            >
            </el-tree>
          </div>
        </div>
      </el-aside>
    </el-row>
    <!-- 预览 -->
    <el-dialog title="预览" :visible.sync="dialogPreviewVisible">
      <div class="preview-item">
        <div class="preview-header">已选择车辆</div>
        <div class="preview-content">
          <span v-for="(item, index) in plateCheckList" :key="index">{{
            item
          }}</span>
        </div>
      </div>
      <div class="preview-item">
        <div class="preview-header">已选择消息模版</div>
        <div class="preview-content">
          <div
            class="msg-text"
            v-for="msg in previewNoticeMsgList"
            :key="msg.id"
          >
            <div style="margin-bottom:4px">
              {{ msg.name }}
            </div>
            <div>
              {{ msg.msg }}
            </div>
          </div>
        </div>
      </div>
      <div class="preview-item">
        <div class="preview-header">已选择通知对象</div>
        <div class="preview-content">
          <div v-for="parent in previewNoticeParentNodeList" :key="parent.id">
            <span style="font-weight:bold">{{ parent.name }} : </span>
            <span v-for="children in parent.headList" :key="children.id">{{
              children.name
            }}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveAddNotice" class="r-20"
          >保存</el-button
        >
        <el-button class="r-20" @click="dialogPreviewVisible = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AddNotice",
  data() {
    return {
      plateNum: "",
      PropertyOwnerName: "",
      noticeMsgIdList: [], // 消息模板多选列表
      noticeMsg: "",
      previewNoticeMsgList: [],
      plateNumList: [],
      plateCheckList: [],
      noticeMessageList: [],
      propertyOwnerList: [],
      dialogPreviewVisible: false,
      defaultProps: {
        children: "headList",
        label: "name",
      },
      selectHeadIdList: [],
      noticeNodeList: [],
      previewNoticeNodeList: [],
      previewNoticeParentNodeList: [],
      previewNoticeChildrenNodeList: [],
    };
  },
  created() {
    if (
      this.$route.params.plateNum ||
      sessionStorage.getItem("noticePlateNum")
    ) {
      this.plateCheckList =
        this.$route.params.plateNum.split(",") ||
        sessionStorage.getItem("noticePlateNum").split(",");
    }
    if (
      this.$route.params.noticeMsgId ||
      sessionStorage.getItem("noticeSysMsgId")
    ) {
      this.noticeMsgIdList.push(
        Number(
          this.$route.params.noticeMsgId ||
            sessionStorage.getItem("noticeSysMsgId")
        )
      );
    }
    if (this.$route.params.noticeId || sessionStorage.getItem("noticeId")) {
      this.selectHeadIdList =
        this.$route.params.noticeId.split(",") ||
        sessionStorage.getItem("noticeId").split(",");
    }
  },
  mounted() {
    this.getPlateNumList();
    this.getNoticeMessageList();
    this.getPropertyOwnerList();
    this.$nextTick(() => {
      this.$refs.tree.setCheckedKeys(this.selectHeadIdList, true); //获取已经设置的资源后渲染
    });
  },
  methods: {
    // 选中节点
    selectClick() {
      // 子节点id数组
      this.selectHeadIdList = this.$refs.tree.getCheckedKeys(true);
      this.noticeNodeList = this.$refs.tree.getCheckedNodes(true);
      this.previewNoticeNodeList = this.$refs.tree.getCheckedNodes(false, true);
    },
    async getPlateNumList() {
      // 获取车牌号列表
      let { data: res } = await this.$axios.get(
        "/api/v3/maintain/monitor/vehicle?plateNum=" + this.plateNum
      );
      if (res.code == 1) {
        this.plateNumList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    async getNoticeMessageList() {
      // 获取消息通知模版列表
      let { data: res } = await this.$axios.get(
        "/api/custom/notifications/msg/template?msg=" + this.noticeMsg
      );
      if (res.code == 1) {
        this.noticeMessageList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    async getPropertyOwnerList() {
      // 获取消息通知模版列表
      let { data: res } = await this.$axios.get(
        "/api/custom/notifications/property/management?name=" +
          this.PropertyOwnerName
      );
      if (res.code == 1) {
        this.propertyOwnerList = res.data;
        this.propertyOwnerList.forEach((property) => {
          property.headList.forEach((head) => {
            head.name = head.headName;
          });
        });
      } else {
        this.$message.warning(res.msg);
      }
    },
    async saveAddNotice() {
      let obj = {};
      obj.account = "";
      obj.dateModified = "";
      obj.id = "";
      obj.msg = "";
      obj.noticeId = this.selectHeadIdList.join(",");
      // 获取选中通知对象节点的name值
      let nameList = [];
      if (this.noticeNodeList.length > 0) {
        this.noticeNodeList.forEach((node) => {
          nameList.push(node.name);
        });
        obj.noticeName = nameList.join(",");
      } else {
        obj.noticeName = "";
      }
      obj.noticeNameMap = null;
      obj.plateNum = this.plateCheckList.join(",");
      obj.sysMsgId = 0;
      obj.sysMsgIdList = this.noticeMsgIdList;
      console.log(obj);
      if (!obj.noticeId || !obj.sysMsgIdList || !obj.plateNum) {
        this.$message.warning("请选择通知车辆，消息模板和通知对象信息！");
        return;
      }
      let id = Number(sessionStorage.getItem("noticeEditId"));
      // this.dialogPreviewVisible = false;
      if (id) {
        // console.log("编辑");
        obj.id = id;
        let { data: res } = await this.$axios.post(
          "/api/custom/notifications/update",
          obj
        );
        if (res.code == 1) {
          this.$message.success("修改成功！");
          this.$router.push({ path: "/CustomNotice" });
        } else {
          this.$message.warning(res.msg);
        }
      } else {
        // 新增
        let { data: res } = await this.$axios.post(
          "/api/custom/notifications/save",
          obj
        );
        if (res.code == 1) {
          this.$message.success("添加成功！");
          this.$router.push({ path: "/CustomNotice" });
        } else {
          this.$message.warning(res.msg);
        }
      }
    },
    preview() {
      this.dialogPreviewVisible = true;
      this.previewNoticeMsgList = [];
      this.noticeMessageList.forEach((msg) => {
        let index = this.noticeMsgIdList.findIndex((id) => msg.id == id);
        if (index != -1) {
          this.previewNoticeMsgList.push({
            id: msg.id,
            name: msg.name,
            msg: msg.msg,
          });
        }
      });
      this.previewNoticeNodeList = this.$refs.tree.getCheckedNodes(false, true);
      // 处理通知对象数据
      this.handleTreePreview();
    },
    handleTreePreview() {
      // 处理数据父节点放一起
      let parentList = [];
      let childList = [];
      this.previewNoticeNodeList.forEach((node) => {
        if (node.headList) {
          parentList.push({ id: node.id, name: node.name, headList: [] });
        } else {
          childList.push({
            id: node.id,
            parentId: node.propertyManagementId,
            name: node.headName,
          });
        }
      });
      childList.forEach((children) => {
        let parentIndex = parentList.findIndex(
          (parent) => parent.id == children.parentId
        );
        if (parentIndex != -1) parentList[parentIndex].headList.push(children);
      });
      this.previewNoticeParentNodeList = parentList;
      this.previewNoticeChildrenNodeList = childList;
    },
    goBack() {
      this.$router.push({ path: "/CustomNotice" });
    },
  },
  beforeDestroy() {
    sessionStorage.removeItem("noticePlateNum");
    sessionStorage.removeItem("noticeSysMsgId");
    sessionStorage.removeItem("noticeId");
    sessionStorage.removeItem("noticeEditId");
  },
};
</script>
<style lang="scss" scoped>
.addNotice-container {
  height: calc(100% - 40px);
  margin: 20px;
  box-sizing: border-box;
  .b-20 {
    margin-bottom: 20px !important;
  }
  .r-20 {
    margin-right: 20px;
    margin-left: 0;
  }
  .content {
    display: flex;
    width: 100%;
    height: calc(100% - 53px);
    padding-left: 20px;
    background: #fff;
    /deep/ .el-aside {
      height: 100%;
      border-right: 1px solid #e4e4e4;
      overflow: hidden;
      .aside-top {
        height: 60px;
        line-height: 60px;
        font-weight: 600;
        margin-right: 10px;
        border-bottom: 1px solid #e4e4e4;
      }
      .aside-bottom {
        height: calc(100% - 71px);
        margin: 10px 10px 0 0;
        margin-left: 0;
        .search {
          .el-input-group__append {
            padding: 0;
          }
          .el-input__inner {
            height: 32px;
            line-height: 32px;
          }
          // .el-input__icon {
          //   height: 32px;
          //   line-height: 32px;
          // }
        }
        .search-data {
          max-height: calc(100% - 63px);
          margin-top: 10px;
          padding: 10px;
          border: 1px solid #9a9a9a;
          border-bottom: none;
          border-right: none;
          overflow-y: auto;
          overflow-x: hidden;
          &.none {
            border: none;
          }
          .el-checkbox-group {
            display: flex;
            flex-direction: column;
          }
          .el-tree-node__content > .el-checkbox {
            margin-bottom: 0;
          }
          .el-checkbox {
            display: flex;
            position: relative;
            cursor: pointer;
            line-height: 1.5; /* 控制行高 */
            font-size: 14px;
            margin-bottom: 15px;
            .el-checkbox__label {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 4; /* 控制文字最多显示4行 */
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: normal; /* 使得white-space属性的值为normal，允许换行 */
            }
          }
        }
      }
    }
  }
  /deep/ .el-dialog {
    width: 700px;
    .el-dialog__body {
      max-height: 520px;
      overflow-y: auto;
      .preview-item {
        margin-bottom: 20px;
        .preview-header {
          margin-bottom: 10px;
          padding-left: 10px;
          font-size: 14px;
          color: #1e1e1e;
          border-left: 5px solid #1890ff;
        }
        .preview-content {
          width: 580px;
          height: 120px;
          max-height: 120px;
          overflow-y: auto;
          padding: 10px 20px;
          border-radius: 8px;
          background: #f1f1f1;
          span {
            margin-right: 10px;
          }
          .msg-text {
            // text-indent: 2em;
            margin-bottom: 10px;
            line-height: 20px;
          }
        }
      }
    }
  }
}
</style>
